import { Ogp } from 'apis/response_types'
import React from 'react'
import styled from 'styled-components'

export default function OgpView(props: { ogp: Ogp | undefined }) {
  const { ogp } = props
  return (
    <>
      {ogp !== undefined ? (
        <OgpWrap>
          <article>
            <OgpLink href={ogp.og_url} rel="nofollow" target="_blank">
              {/* <OgpUrl>{ogp.og_url}</OgpUrl> */}
              {/* <OgpSiteName>{ogp.og_site_name}</OgpSiteName> */}
              <OgpTitle>{ogp.og_title}</OgpTitle>
              <OgpDescription>
                {ogp.og_description && ogp.og_description.length > 100
                  ? ogp.og_description.substring(0, 100) + '...'
                  : ogp.og_description}
              </OgpDescription>
              {ogp.og_iamge ? <OgpImage>{ogp.og_iamge}</OgpImage> : ''}
            </OgpLink>
          </article>
        </OgpWrap>
      ) : (
        <></>
      )}
    </>
  )
}

const OgpWrap = styled.aside`
  margin-top: 12px;
  margin-bottom: 12px;
`
const OgpLink = styled.a`
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  border-radius: 8px;
  @media (max-width: 640px) {
    padding: 12px 16px;
  }
`
// const OgpUrl = styled.p`
//   font-size: 12px !important;
//   font-weight: bold;
//   margin-bottom: 4px !important;
// `
// const OgpSiteName = styled.p``
const OgpTitle = styled.h2`
  font-size: 14px !important;
  font-weight: bold;
  margin-bottom: 8px !important;
  color: #1c68a5;
`
const OgpDescription = styled.p`
  font-size: 13px !important;
  color: #333333;
`
const OgpImage = styled.p`
  margin-top: 8px;
  img {
    max-width: 100%;
    object-fit: cover;
    vertical-align: bottom;
  }
`
